import Controller from '@ember/controller';
import { KIOSK_ENTRY_URL_KEY } from 'invite-sign/utils/kiosk-recovery';

export default class TryAgainController extends Controller {
  // On a shared-device kiosk the screen auto-recovers to the welcome screen
  // (see the route), so "scan the QR code again" would be misleading there.
  get isKioskRecovering(): boolean {
    try {
      return Boolean(sessionStorage.getItem(KIOSK_ENTRY_URL_KEY));
    } catch {
      return false;
    }
  }
}
